var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAndroid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "android",
    width: 18.474,
    height: 22.174,
    viewBox: "0 0 18.474 22.174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7698",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "Path_4653",
    d: "M44.113 170.787a1.386 1.386 0 0 0-1.386 1.386v6.466a1.386 1.386 0 1 0 2.771 0v-6.466a1.386 1.386 0 0 0-1.385-1.386z",
    transform: "translate(-42.727 -163.392)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "Path_4654",
    d: "M406.779 170.787a1.385 1.385 0 0 0-1.385 1.386v6.466a1.386 1.386 0 1 0 2.771 0v-6.466a1.385 1.385 0 0 0-1.386-1.386z",
    transform: "translate(-389.69 -163.392)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "Path_4655",
    d: "M138.682 170.787h-10.16a.462.462 0 0 0-.462.462v7.389a2.309 2.309 0 0 0 1.847 2.263v3.279a1.386 1.386 0 0 0 2.771 0v-3.233h1.847v3.233a1.386 1.386 0 0 0 2.771 0v-3.28a2.309 2.309 0 0 0 1.847-2.263v-7.389a.462.462 0 0 0-.461-.461z",
    transform: "translate(-124.365 -163.392)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "Path_4656",
    d: "M136.958 1.919l1.126-1.125a.462.462 0 0 0-.642-.664l-.011.011-1.311 1.312a6.321 6.321 0 0 0-5.037 0L129.771.14a.462.462 0 0 0-.653.653l1.125 1.126a4.874 4.874 0 0 0-2.184 4.09.462.462 0 0 0 .462.462h10.161a.462.462 0 0 0 .462-.462 4.874 4.874 0 0 0-2.186-4.09z",
    transform: "translate(-124.364 0)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7699",
    transform: "translate(6.466 3.7)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_604",
    cx: 0.462,
    cy: 0.462,
    r: 0.462,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_605",
    cx: 0.462,
    cy: 0.462,
    r: 0.462,
    fill: "#fff",
    transform: "translate(4.618)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.af00959d.svg";
export { ForwardRef as ReactComponent };